module.exports = __webpack_public_path__ + "img/60.d8e1a738.png";